import axios, { AxiosInstance } from 'axios';
import toast from 'react-hot-toast';
import config from 'config';
import { authState } from 'state/auth';

export default function useApi(): AxiosInstance {
  const batman = axios.create({
    baseURL: config.rest.uri,
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
    },
  });

  batman.interceptors.request.use(
    function (config) {
      const authorization = authState().token;
      if (authorization) {
        config = {
          ...config,
          headers: {
            ...config.headers,
            Authorization: authorization.startsWith('Bearer ') ? authorization : `Bearer ${authorization}`,
          } as any,
        };
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  batman.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.response ||
        (error.message === 'Network Error' ? 'Network connection lost. Connect and try again' : 'Unable to process request');

      if (error?.response?.status === 403 && (message.includes('Password expired') || message.includes('Password change required'))) {
        toast(JSON.stringify({ type: 'warning', title: 'Password Update Required', description: message }));
        window.location.href = '/change-password';
        return Promise.reject(error);
      }

      toast(JSON.stringify({ type: 'error', title: message }));
      return Promise.reject(error);
    },
  );

  return batman;
}
